<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AuditModal',
})
</script>
<template>
    <a-modal title="审核" :width="1200" :open="true" :footer="false" @cancel="() => emit('cancel')" class="audit-modal">
        <div class="audit-container">
            <!-- ====== 顶部：核心身份信息 ====== -->
            <div class="identity-card">
                <a-row :gutter="16" align="middle">
                    <a-col :span="24">
                        <a-space size="large" align="start">
                            <a-avatar :size="72"
                                :src="$store.state.user.image_domain + props.detailData.wechat_picture">
                                {{ props.detailData.customer_name?.charAt(0) || '?' }}
                            </a-avatar>
                            <div class="identity-info">
                                <div class="identity-name">
                                    <span class="name">{{ isEmpty(props.detailData.customer_name) }}</span>
                                    <a-tag color="blue" bordered>{{ isEmpty(props.detailData.job_title) }}</a-tag>
                                </div>
                                <div class="identity-company">
                                    <span class="label">就职公司：</span>
                                    <span class="value">{{ isEmpty(props.detailData.company_name) }}</span>
                                </div>
                                <div class="identity-contact">
                                    <a-space size="middle">
                                        <span>电话：{{ isEmpty(props.detailData.customer_tel) }}</span>
                                        <span>邮箱：{{ isEmpty(props.detailData.mail_address) }}</span>
                                    </a-space>
                                </div>
                            </div>
                        </a-space>
                    </a-col>
                </a-row>
            </div>

            <!-- ====== 详细信息网格 ====== -->
            <a-row :gutter="[16, 16]">
                <!-- 公司信息 -->
                <a-col :xs="24" :md="12">
                    <a-card size="small" class="info-card" :bordered="true">
                        <template #title>
                            <span>公司信息</span>
                        </template>
                        <a-descriptions :column="1" size="small" bordered>
                            <a-descriptions-item label="就职公司名称">
                                {{ isEmpty(props.detailData.company_name) }}
                            </a-descriptions-item>
                            <a-descriptions-item label="就职公司统一社会信用代码">
                                {{ isEmpty(props.detailData.finance_social_credit_code) }}
                            </a-descriptions-item>
                            <a-descriptions-item label="就职公司地址">
                                {{ isEmpty(props.detailData.company_address) }}
                            </a-descriptions-item>
                            <a-descriptions-item label="公司营业执照照片">
                                <div v-if="props.detailData.company_business_license?.length > 0">
                                    <span class="mr-1x mb-1x"
                                        v-for="(item, index) in props.detailData.company_business_license" :key="index">
                                        <a-image :width="100" :height="100"
                                            :src="$store.state.user.image_domain + item"></a-image>
                                    </span>
                                </div>
                                <div v-else>无</div>
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-card>
                </a-col>

                <!-- 个人信息 -->
                <a-col :xs="24" :md="12">
                    <a-card size="small" class="info-card" :bordered="true">
                        <template #title>
                            <span>个人信息</span>
                        </template>
                        <a-descriptions :column="1" size="small" bordered>
                            <a-descriptions-item label="职位名称">
                                {{ isEmpty(props.detailData.job_title) }}
                            </a-descriptions-item>
                            <a-descriptions-item label="推荐人手机号码">
                                {{ isEmpty(props.detailData.referrer_tel) }}
                            </a-descriptions-item>
                            <a-descriptions-item label="紧急联系人手机号码">
                                {{ isEmpty(props.detailData.exigency_tel) }}
                            </a-descriptions-item>
                            <a-descriptions-item label="证明材料">
                                <div v-if="props.detailData.job_certificate?.length > 0">
                                    <a :download="item.name" :href="$store.state.user.image_domain + item.url"
                                        target="_blank" v-for="(item, index) in props.detailData.job_certificate"
                                        :key="index">
                                        {{ item.name }}
                                    </a>
                                </div>
                                <div v-else>无</div>
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-card>
                </a-col>

                <!-- 微信信息 -->
                <a-col :xs="24" :md="12">
                    <a-card size="small" class="info-card" :bordered="true">
                        <template #title>
                            <span>微信信息</span>
                        </template>
                        <a-descriptions :column="1" size="small" bordered>
                            <a-descriptions-item label="微信号">
                                {{ isEmpty(props.detailData.wechat_id) }}
                            </a-descriptions-item>
                            <a-descriptions-item label="微信昵称">
                                {{ isEmpty(props.detailData.wechat_name) }}
                            </a-descriptions-item>
                            <a-descriptions-item label="微信头像">
                                <a-image v-if="props.detailData.wechat_picture?.length > 0" :width="100" :height="100"
                                    :src="$store.state.user.image_domain + props.detailData.wechat_picture">
                                </a-image>
                                <div v-else>无</div>
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-card>
                </a-col>

                <!-- 身份证信息 -->
                <a-col :xs="24" :md="12">
                    <a-card size="small" class="info-card" :bordered="true">
                        <template #title>
                            <span>身份证信息</span>
                        </template>
                        <a-descriptions :column="1" size="small" bordered>
                            <a-descriptions-item label="身份证号码">
                                {{ isEmpty(props.detailData.identity_card_number) }}
                            </a-descriptions-item>
                            <a-descriptions-item label="民族">
                                {{ isEmpty(props.detailData.nationality) }}
                            </a-descriptions-item>
                            <a-descriptions-item label="住所">
                                {{ isEmpty(props.detailData.identity_card_address) }}
                            </a-descriptions-item>
                            <a-descriptions-item label="身份证有效期开始时间">
                                {{ isEmpty(props.detailData.identity_card_start_time) }}
                            </a-descriptions-item>
                            <a-descriptions-item label="身份证有效期结束时间">
                                {{ isEmpty(props.detailData.identity_card_expiration_time) }}
                            </a-descriptions-item>
                            <a-descriptions-item label="身份证人像面照片">
                                <a-image v-if="props.detailData.identity_card_front" :width="300" :height="200"
                                    :src="$store.state.user.image_domain + props.detailData.identity_card_front">
                                </a-image>
                                <div v-else>无</div>
                            </a-descriptions-item>
                            <a-descriptions-item label="身份证国徽面照片">
                                <a-image v-if="props.detailData.identity_card_contrary" :width="300" :height="200"
                                    :src="$store.state.user.image_domain + props.detailData.identity_card_contrary">
                                </a-image>
                                <div v-else>无</div>
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-card>
                </a-col>
            </a-row>

            <!-- ====== 底部：审核操作 ====== -->
            <div class="audit-actions">
                <a-card size="small" :bordered="true">
                    <template #title>
                        <span>审核操作</span>
                    </template>
                    <div class="audit-form-wrapper">
                        <div class="audit-form-item">
                            <div class="form-label">
                                <span class="required">*</span> 所在城市
                            </div>
                            <div class="form-control">
                                <a-input v-model:value="formData.company_city" placeholder="请输入所在城市" />
                                <div class="city-tags">
                                    如：
                                    <a-tag color="green" @click="formData.company_city = '长沙'">长沙</a-tag>
                                    <a-tag color="green" @click="formData.company_city = '西安'">西安</a-tag>
                                </div>
                            </div>
                        </div>
                        <div class="audit-form-item">
                            <div class="form-label">操作意见</div>
                            <div class="form-control">
                                <a-input v-model:value="formData.reason" placeholder="选填:输入通过或者不通过的理由" />
                            </div>
                        </div>
                        <div class="audit-form-item">
                            <div class="form-label">&nbsp;</div>
                            <div class="form-control">
                                <a-space>
                                    <a-popconfirm title="确定不通过?" @confirm="verificatioChange(2)">
                                        <a-button type="primary" danger>不通过</a-button>
                                    </a-popconfirm>
                                    <a-popconfirm title="确定通过?" @confirm="verificatioChange(1)">
                                        <a-button type="primary">通过</a-button>
                                    </a-popconfirm>
                                </a-space>
                            </div>
                        </div>
                    </div>
                </a-card>
            </div>
        </div>
    </a-modal>
</template>

<script lang="ts" setup name="AuditModal">
import { reactive } from 'vue'
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'
const $store = useStore()
import baseService from '@/utils/http/axios'

const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})

const emit = defineEmits(['cancel'])

interface IformData {
    company_city: string
    reason: string
}

const formData = reactive<IformData>({
    company_city: '',
    reason: ''
})

const isEmpty = (val: any) => {
    if (val && val.toString().length > 0) {
        return val
    }
    return '无'
}

const verificatioChange = (type: number) => {
    if (!formData.company_city) {
        message.error('请填写所在城市')
        return
    }
    let requestParam = {
        url: '/admin/v1/filingsCheck/' + props.detailData.id,
        method: 'put',
        data: Object.assign({ status: type }, formData)
    }
    baseService(requestParam)
        .then(() => {
            message.success('操作成功')
            emit('cancel')
        })
        .catch((error) => {
            if (error?.msg) {
                message.error(error.msg)
            } else {
                message.error('操作失败，请联系管理员')
            }
        })
}
</script>

<style lang="less" scoped>
.audit-modal {
    :deep(.ant-modal-body) {
        padding: 24px;
        max-height: 80vh;
        overflow-y: auto;
    }
}

.audit-container {
    .identity-card {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 12px;
        padding: 20px 24px;
        margin-bottom: 20px;
        color: #fff;

        .identity-info {
            .identity-name {
                display: flex;
                align-items: center;
                gap: 8px;
                flex-wrap: wrap;
                margin-bottom: 6px;

                .name {
                    font-size: 22px;
                    font-weight: 600;
                }

                :deep(.ant-tag) {
                    font-size: 13px;
                    border-radius: 4px;
                    margin: 0;
                }
            }

            .identity-company {
                font-size: 14px;
                margin-bottom: 4px;
                opacity: 0.95;

                .label {
                    opacity: 0.7;
                }

                .value {
                    font-weight: 500;
                }
            }

            .identity-contact {
                font-size: 14px;
                opacity: 0.9;
            }
        }
    }

    .info-card {
        height: 100%;
        border-radius: 8px;

        :deep(.ant-card-head) {
            background: #fafafa;
            border-bottom: 1px solid #f0f0f0;
            padding: 0 16px;
            min-height: 44px;

            .ant-card-head-title {
                padding: 10px 0;
                font-weight: 600;
                font-size: 14px;
            }
        }

        :deep(.ant-card-body) {
            padding: 12px 16px;
        }

        :deep(.ant-descriptions) {
            .ant-descriptions-item-label {
                width: 160px;
                background: #fafafa;
                font-weight: 500;
                color: #666;
            }

            .ant-descriptions-item-content {
                padding: 8px 12px;
            }
        }
    }

    .audit-actions {
        margin-top: 16px;

        :deep(.ant-card-head) {
            background: #fafafa;
            border-bottom: 1px solid #f0f0f0;
            padding: 0 16px;
            min-height: 44px;

            .ant-card-head-title {
                padding: 10px 0;
                font-weight: 600;
                font-size: 14px;
            }
        }

        :deep(.ant-card-body) {
            padding: 16px 20px;
        }

        .audit-form-wrapper {
            display: flex;
            gap: 16px;
            align-items: flex-start;

            .audit-form-item {
                flex: 1;
                display: flex;
                flex-direction: column;

                .form-label {
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                    font-weight: 500;
                    margin-bottom: 8px;
                    min-height: 22px;
                    line-height: 22px;
                    white-space: nowrap;

                    .required {
                        color: #ff4d4f;
                        margin-right: 4px;
                    }
                }

                .form-control {
                    flex: 1;

                    .city-tags {
                        margin-top: 8px;

                        :deep(.ant-tag) {
                            cursor: pointer;
                            transition: all 0.3s;

                            &:hover {
                                transform: scale(1.05);
                                opacity: 0.8;
                            }
                        }
                    }
                }
            }
        }
    }
}

.mr-1x {
    margin-right: 8px;
}

.mb-1x {
    margin-bottom: 8px;
}

@media (max-width: 768px) {
    .identity-card {
        .identity-info {
            .identity-name {
                .name {
                    font-size: 18px !important;
                }
            }
        }
    }

    .audit-actions {
        .audit-form-wrapper {
            flex-direction: column;

            .audit-form-item {
                width: 100%;
            }
        }
    }
}
</style>
